module.exports = __webpack_public_path__ + "static/vishal-bhalla-400w-103018-10948e0b8767cc4aafce66b89e24be80.jpg";